import React from 'react';
import { X } from 'lucide-react';
import Button from '../../components/Button';

interface BulkActionsBarProps {
  count: number;
  noun: string;
  onClear: () => void;
  /** Action buttons */
  children: React.ReactNode;
}

/** Appears above a list when rows are selected; hosts the bulk actions. */
const BulkActionsBar: React.FC<BulkActionsBarProps> = ({ count, noun, onClear, children }) => {
  if (count === 0) return null;
  return (
    <div className="card flex flex-wrap items-center gap-2 border-l-4 border-primary-600 p-3">
      <span className="text-sm font-medium text-text-primary dark:text-text-dark-primary">
        {count} {noun}
        {count === 1 ? '' : 's'} selected
      </span>
      <div className="flex flex-wrap items-center gap-2">{children}</div>
      <Button variant="ghost" size="sm" icon={X} onClick={onClear} className="ml-auto">
        Clear
      </Button>
    </div>
  );
};

export default BulkActionsBar;

/** Toast copy for bulk results: "5 updated, 2 skipped (system administrator)" */
export const bulkResultMessage = (
  verb: string,
  data: { updated: string[]; skipped: Array<{ id: string; reason: string }> }
): string => {
  const parts = [`${data.updated.length} ${verb}`];
  if (data.skipped.length > 0) {
    const reasons = Array.from(new Set(data.skipped.map((entry) => entry.reason)));
    parts.push(`${data.skipped.length} skipped (${reasons.join('; ')})`);
  }
  return parts.join(', ');
};
